import { InputAdornment } from "@mui/material";
import { useFormContext, useFormState } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { TbHeading, TbNotes } from "react-icons/tb";

import { CommonHelperText, CommonInput, CommonLabel } from "@/components/CommonInput";
import { User } from "@/types/user.types";

// removed unused: NotificationCategories
import CreateNotificationCategorySelector from "./CreateNotificationCategorySelector";
import { CreateNotificationFormType } from "./CreateNotificationForm";
import CreateNotificationPrioritySelector from "./CreateNotificationPrioritySelector";
import CreateNotificationRecipients from "./CreateNotificationRecipients";

function CreateNotificationFormContent({ users, loading }: { users: User[]; loading: boolean }) {
    const { register } = useFormContext<CreateNotificationFormType>();
    const { errors } = useFormState<CreateNotificationFormType>(); // use this instead of useFormContext for errors

    const { t } = useTranslation();
    return (
        <>
            <CommonLabel required label={t("notificationTitle")} className=" col-span-5">
                <CommonInput
                    placeholder={t("placeholders.enter", { field: t("notificationTitle") })}
                    {...register("title")}
                    error={!!errors?.title}
                    startAdornment={
                        <InputAdornment position="start">
                            <TbHeading />
                        </InputAdornment>
                    }
                />
                <CommonHelperText text={errors?.title?.message || ""} />
            </CommonLabel>
            <span></span>

            <CreateNotificationCategorySelector />
            <CreateNotificationPrioritySelector />

            <CommonLabel label={t("notificationContent")} className="col-span-full">
                <CommonInput
                    disabled={false}
                    placeholder={t("placeholders.enter", { field: t("notificationContent") })}
                    multiline
                    rows={3}
                    classes={{
                        root: "!py-2",
                    }}
                    {...register("body")}
                    error={!!errors?.body}
                    endAdornment={
                        <InputAdornment position="end">
                            <TbNotes />
                        </InputAdornment>
                    }
                ></CommonInput>
                <CommonHelperText text={errors?.body?.message || ""} />
            </CommonLabel>
            <CreateNotificationRecipients users={users} loading={loading} />
        </>
    );
}

export default CreateNotificationFormContent;
